module.exports = __webpack_public_path__ + "media/images/products/marketplace/1-32c8570c49e1e8a6b402fb3862d341a1.jpg";